import { Link } from "react-router-dom";
import { HpWordmark } from "./HpWordmark";

export type AppBrandMarkVariant = "sidebar" | "login" | "compact";

export interface AppBrandMarkProps {
  variant?: AppBrandMarkVariant;
  /** Link product mark to home. Default true for sidebar/compact. */
  linkToHome?: boolean;
  className?: string;
}

/** Sidebar / login brand lockup: HP wordmark + Claims Radar product line. */
export function AppBrandMark({ variant = "sidebar", linkToHome = true, className = "" }: AppBrandMarkProps) {
  if (variant === "login") {
    return (
      <div className={["text-center", className].join(" ")}>
        <HpWordmark size="login" className="mx-auto object-center" />
        <h1 className="mt-4 font-serif text-lg font-semibold text-zinc-900">Claims Radar</h1>
        <p className="mt-1 text-sm text-zinc-500">Regulatory claims intelligence</p>
      </div>
    );
  }

  if (variant === "compact") {
    const content = (
      <div className={["flex min-w-0 items-center gap-2", className].join(" ")}>
        <HpWordmark size="sidebar-mini" />
        <span className="truncate border-l border-zinc-200 pl-2 text-sm font-semibold text-zinc-900">Claims Radar</span>
      </div>
    );
    return linkToHome ? (
      <Link to="/" className="block min-w-0 hover:opacity-90">
        {content}
      </Link>
    ) : (
      content
    );
  }

  const sidebarContent = (
    <div className={className}>
      <div className="flex items-center gap-3">
        <HpWordmark size="sidebar-md" className="shrink-0" />
        <div className="min-w-0 self-stretch border-l border-zinc-200 pl-3">
          <div className="text-sm font-semibold leading-tight text-zinc-900">Claims Radar</div>
        </div>
      </div>
      <p className="mt-2 text-xs leading-snug text-zinc-500">Regulatory claims intelligence</p>
    </div>
  );

  return linkToHome ? (
    <Link to="/" className="block rounded-lg transition-opacity hover:opacity-90">
      {sidebarContent}
    </Link>
  ) : (
    sidebarContent
  );
}
